import { Injectable } from '@angular/core';
import { RequestConfigImplementation, REQUEST_METHODS, HTTPWrapperContext, XHR_STRATEGIES } from '@ptl/xhr';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { ProducerStateStructure } from 'src/app/angular-elements/producer/configs/interfaces/producerStateStructure.interface';
import { UserInfoStateStructure, LOGIN_INFO_REDUCER_NAME } from '@ptl/account-management';
import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ProducerFileUploadService {

    uploadableFiles: FileList;
    fileValue: string;

    constructor(
        private httpClient: HTTPWrapperContext,
        private reducerUtilityService: ReducerUtilityService
    ) { }

    setFilesForUpload(x: FileList) {
        this.uploadableFiles = x;
    }

    async uploadFiles(): Promise<any> { /** @Todo add the response type */
      if (
        this.uploadableFiles &&
        this.uploadableFiles.length > 0
      ) {
        const producerInfo: ProducerStateStructure = this.reducerUtilityService.getState('Producer');

        const loginInfo: UserInfoStateStructure
          = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);

        const agentId = producerInfo.selectedAgency.npnNo;
        const agencyId = producerInfo.selectedAgency.agencyId;
        const toAddress = loginInfo.userInfo.email;

        const payload = new FormData();
        payload.append('agent_id', agentId);
        payload.append('agency_id', agencyId);
        payload.append('toaddress', toAddress);
        payload.append('responseType', 'JSON');

        payload.append(
          `file`,
          this.uploadableFiles[0]
        );

        const requestConfig = new RequestConfigImplementation({
            method: REQUEST_METHODS.POST,
            url: '/cmcsnr/x-services/emailService/files',
            withCredentials: true,
            POST_OR_PUT_PAYLOAD: payload,
            contentType: 'force_undefined',
            headers: new HttpHeaders({
              'x-hmhs-test-backend': environment.external.engen.eBill.overrideEnv
            })
        });

        this.httpClient.setStrategy(XHR_STRATEGIES.DATAPOWER_MIDDLEWARE);
        return this.httpClient.makeRequest(requestConfig);
      }
      return true;
    }


}
